<template>
  <div class="tradeApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent :idx='3'></headComponent>
    <div class="h"></div>
    <div class="proBg" :style="'background: url('+baseUrl+tradeDetail.images+') no-repeat center;'">
      <div class="txt">
        <h2 class="tit">{{tradeDetail.title}}</h2>
        <div class="desc"><p>{{tradeDetail.brief}}。</p></div>
      </div>
    </div>
    <div class="tab">
      <ul>
        <li @click="clickTrade(i)" :class="id == item.id ? 'on' : ''" v-for="(item,i) in setTrade"><a href="javascript:;">{{item.title}}</a></li>
      </ul>
    </div>

    <div class="main">
      <dl>
        <dd v-for="(item,i) in setCase">
          <a href="javascript:;" @click="$router.push('tradedetail?id='+item.id)">
            <div class="pic">
              <img :src="baseUrl+item.images" alt="">
            </div>
            <div class="tit">
              <h3>{{tradeDetail.title}}</h3>
              <div class="tips">{{item.title}}</div>
              <p>{{item.content.replace(/<[^>]+>/gim,"")}}</p>
            </div>
            <span class="btn">了解更多  &gt;</span>
          </a>
        </dd>        
      </dl>
    </div>
    <footComponent></footComponent>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        proBg:require('../../../assets/images/probg.png'),
        setTrade:[],
        id:'',
        tradeDetail:[],
        setCase:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$fileurl;
    },
    mounted() {
      this.beforeMount();
      this.getTrade();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      clickTrade:function(i){
        var that = this;
        that.id = that.setTrade[i].id;
        var arr = {
          'title':that.setTrade[i].title,
          'brief':that.setTrade[i].brief,
          'images':that.setTrade[i].images
        };
        that.tradeDetail = arr;
        that.getCase(that.id);
      },
      getTrade:function(){
        var that = this;
        that.fullscreenLoading = true;
        var id = that.$route.query.id
        $.ajax({
          type:'post',
          url:that.$host+'home/index/trade',
          dataType:'json',
          success:function(data){
            that.setTrade = data.data;
            that.id = that.$route.query.id == undefined ? data.data[0].id : that.$route.query.id;
            var len = data.data.length;
            for(var i=0;i<len;i++){
              if(that.id == data.data[i].id){
                var arr = {
                  'title':data.data[i].title,
                  'brief':data.data[i].brief,
                  'images':data.data[i].images
                };
                that.tradeDetail = arr;
              }
            }
            that.getCase(that.id);
            that.fullscreenLoading = false;
          }
        })
      },

      getCase:function(id){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/case',
          data:{
            id:id
          },
          dataType:'json',
          success:function(data){
            that.setCase = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .tradeApp .el-message-box{
    width:30%
  }
  .tradeApp{
    width:100%;
    margin:0 auto;
    background:#F7F9FA
  }
  .tradeApp .h{
    height:96px
  }
  .tradeApp .proBg{
    height: 35.06vw;
    color:#fff;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }
  .tradeApp .proBg .txt{
    position: absolute;
    top: 50%;
    color: #fff;
    transform: translateY(-50%);
    left: 8.333vw;
  }
  .tradeApp .proBg .txt .tit{
    font-size: 3.125vw;
    margin-bottom:20px;
    font-weight: normal;
  }
  .tradeApp .proBg .txt .desc {
    font-size: 15px;
  }

  .tradeApp .main{
    margin:0 auto;
    max-width:1600px;
  }
  .tradeApp .main dl dt{
    font-size:20px;
    font-weight:bold;
    padding:25px 0 12px 0
  }
  .tradeApp .main dl dd{
    float:left;
    width:25%;
    margin-bottom:12px;
  }
  .tradeApp .main dl:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .tradeApp .main dl dd a{
    display: block;
    background-color: #fff;
    margin: 0 12px 0 0;
    padding-bottom:25px;
  }
  .tradeApp .main dl dd a .tit{
    margin-bottom:20px;
    padding: 0 10px;
  }
  .tradeApp .main dl dd a .tit .tips{
    color: #333;
    font-size:17px;
    margin-bottom:12px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .tradeApp .main dl dd a .tit h3{
    color: #4470AF;
    font-size: 15px;
    padding:10px 0
  }
  .tradeApp .main dl dd a .tit p{
    line-height: 1.81;
    color: #888;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    font-size: 15px;
  }
  .tradeApp .main dl dd a .pic img{
    width:100%;
    display:block;
    margin:0 auto
  }
  .tradeApp .main dl dd a  .btn{
    border: 1px solid rgba(51,51,51,.2);
    color: #777;
    display: block;
    width:60%;
    margin:0 auto;
    height:35px;
    text-align:center;
    line-height:35px;
    font-size:15px;
  }
  .tradeApp .main dl dd a:hover .btn{
    border-color: #4470AF;
    background-color: #4470AF;
    color: #fff;
  }

  .tradeApp .tab{
    background:#fff;
    height:45px;
    margin-bottom:15px;
    overflow: hidden;
  }
  .tradeApp .tab ul{
    max-width:1600px;
    margin:0 auto;
  }
  .tradeApp .tab ul li{
    display:inline-block;
    line-height:45px;
  }
  .tradeApp .tab ul li a{
    display:block;
    padding-right: 50px;
    color:#333
  }
  .tradeApp .tab ul li.on a,.tradeApp .tab ul li a:hover{
    color:#4470AF;
    font-weight:bold
  }
  
  @media only screen and (max-width: 1199px) {
    .tradeApp .header,.tradeApp .h{
      height:60px;
    }
    .tradeApp .header .logo img{
      height:25px;
      margin:17.5px 12px 0 12px
    }
    .tradeApp .header .nav{
      text-align:right
    }
    .tradeApp .header .nav li{
      margin:0 1.8vw
    }
    .tradeApp .header .nav .close{
      display:none
    }
    .tradeApp .header .nav a{
      line-height:60px;
      font-size:14px
    }

    .tradeApp .proBg{
      font-size:18px;
    }
    .tradeApp .main dl dd{
      width:50%
    }
  } 
</style>